import BackButtonAndTitle from '../../components/retailer-shop/BackButtonAndTitle'
import ShopEditForm from '../../components/retailer-shop/ShopEditForm'

const ShopEditPage = () => {
  return (
    <div className="main-container">
      <BackButtonAndTitle title="Edit Shop Details" />
      <ShopEditForm />
    </div>
  )
}

export default ShopEditPage
